module.exports = __webpack_public_path__ + "static/media/Impact-01.3f85e25b.svg";